/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Redirect, Switch } from 'react-router';
// material
import { SubDivision } from '@insticator/insticator-ui'; // iui-material
// pages
import EmbedContent from 'pages/dashboard/embeds/analytics/embedcontent/embedcontent_container';
// utils
import { PrivateRoute } from '@insticator/insticator-ui'; // iui-utils
// // styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/analytics/embed_analytics_styles';



/* ========== ~~~~~~~~~~ EMBED ANALYTICS ~~~~~~~~~~ ========== */
const EmbedAnalytics = (props) => 
    <Switch>
        <SubDivision name={`embedAnalytics`} klass={props.classes.embedAnalytics}>
            <div id={`main`}>
                <Switch>
                    {/*<Route path='/dashboard/embeds/analytics/embedcontent' component={EmbedContent} />*/}
                    <PrivateRoute permitted={props.isDataReceived} exact path='/dashboard/embeds/analytics/embedcontent' redirectTo='/dashboard/embeds' component={EmbedContent} />
                    <Redirect to='/error/404' />
                </Switch>
            </div>
        </SubDivision>
    </Switch>



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedAnalytics);
